import type React from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";

import { FeedPanelContext } from "@/components/DriverView/ui/FeedPanelContext";
import { topHeaderHeightPx } from "@/components/NewDesign/newDesignUtils";
import { ampli } from "@/config";
import PanelHeader from "@/ui/PanelHeader";

/** Feed panel title bar wired to the app: close comes from FeedPanelContext and fires analytics. */
export default function ConnectedPanelHeader({ children }: { children: React.ReactNode }) {
  const { closePanel } = useContext(FeedPanelContext);
  const { feedId } = useParams();

  return (
    <PanelHeader
      height={topHeaderHeightPx}
      onClose={
        closePanel
          ? () => {
              ampli.exitFeed({ feedId });
              closePanel();
            }
          : undefined
      }
    >
      {children}
    </PanelHeader>
  );
}
